import RoadMapSection from 'components/roadMapSection';
import Section from 'components/Section';
import { useRouter } from 'next/router';
import Head from 'next/head';

export default function RoadMap() {
    return (
        <>
            <Head>
                <title>Roadmap | tabExtend</title>
                <meta property="og:url" content="https://www.tabextend.com/roadmap" />
                <meta name="robots" content="index,follow" />
                <link rel="canonical" href="https://www.tabextend.com/roadmap" />
            </Head>
            <Section>
                <div
                    style={{
                        height: '1.2rem',
                        display: 'flex',
                        flex: '1',
                        height: '44px'
                    }}
                >
                    <p
                        style={{
                            margin: 'auto',
                            fontWeight: '500'
                        }}
                    >
                        Coming soon
                    </p>
                </div>

                {/* <RoadMapSection boldTitle={true} /> */}
                <div style={{ height: '2rem' }}></div>
            </Section>
        </>
    );
}
